/** @format */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Backbtn } from '../../components/button/backBtn';
import { Button } from '../../components/button';
import { withStyles } from '@material-ui/core/styles';
import InnerHTML from 'dangerously-set-html-content';
import { filesize } from 'filesize';
import { Grid, Switch } from '@material-ui/core';
import axiosInstance from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';
import useAuth from 'src/hooks/useAuth';
import { UserRating } from 'src/components/userRating';
// import 'antd/dist/antd.css';

const IOSSwitch = withStyles(theme => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1)
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none'
      }
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff'
    }
  },
  thumb: {
    width: 24,
    height: 24
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  checked: {},
  focusVisible: {}
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }}
      {...props}
    />
  );
});

const ContentBlock = props => {
  const { kb, content, nid, rating, clearError, rateDetail, loading, ratingError, ratingSuccess, isNews } = props;
  const { t } = useTranslation();
  const [cookieContent, setCookieContent] = useState(null);
  const { pageId, type } = useParams();
  const history = useHistory();
  const { user } = useAuth();

  // debugger
  useEffect(() => {
    let VDO_cookieSettings = getCookie('VDO_cookieSettings');
    if (VDO_cookieSettings) {
      let removeBr1 = VDO_cookieSettings.replace('{', '');
      let removeBr2 = removeBr1.replace('}', '');
      let value = removeBr2.split(':');
      let trueFalse = JSON.parse(value[1]);
      setCookieContent(trueFalse);
    }
  }, []);

  const getCookie = cname => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  useEffect(() => {
    let cookiePage = content.title;
    if (cookiePage === 'Cookies') {
      const element = <Switch onChange={onChange} defaultChecked={cookieContent} />;
      ReactDOM.render(element, document.getElementById('switch_btn'));
    }
    if (content.body) {
      const images = document.querySelectorAll('.content-block img');
      if (images.length) {
        images.forEach(image => {
          const caption = image.dataset.caption;
          if (caption) {
            const captionParagraph = document.createElement('p');
            captionParagraph.innerText = caption;
            captionParagraph.className = 'caption';
            image.after(captionParagraph);
          }
        });
      }
      // START responsive more than two images in the table
      const handleResizeEvent = () => {
        const tableRows = document.querySelectorAll('.content-block table tr');
        tableRows.forEach(r => {
          if (window.innerWidth < 1024) {
            const rowTds = r.querySelectorAll('td');
            const imagesInTable = r.querySelectorAll('img');
            if (rowTds.length >= 2 && imagesInTable.length >= 2) {
              r.style = 'display: flex; flex-direction: column';
              rowTds.forEach(c => {
                const imgs = r.querySelectorAll('img');
                imgs.forEach(img => {
                  img.style = 'margin: 0';
                });
              });
            }
          } else {
            r.style = '';
            const rowTds = r.querySelectorAll('td');
            rowTds.forEach(c => {
              const imgs = r.querySelectorAll('img');
              imgs.forEach(img => {
                img.style = '';
              });
            });
          }
        });
      };
      window.addEventListener('resize', handleResizeEvent);

      return () => {
        window.removeEventListener('resize', handleResizeEvent);
      };
      // END responsive more than two images in the table
    }
    // eslint-disable-next-line
  }, [props, content]);

  function onChange(checked) {
    if (checked === false) {
      setCookie('VDO_cookieSettings', "{'Google_Analytics_cookieSwitch':false}", 30);
    } else {
      setCookie('VDO_cookieSettings', "{'Google_Analytics_cookieSwitch':true}", 30);
    }
  }

  const Downloads = ({ downloads, tracking }) => {
    return (
      <>
        <h2 className="downloadTitle">Downloads</h2>
        <Grid container spacing={8}>
          {downloads.map((item, index) => (
            <Grid item key={index}>
              <a
                href={item.link}
                onClick={() => content.downloadTracking && tracking(item)}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="content-block-download-wrapper"
              >
                <div className="download">
                  {/* <img className='image' src={DownloadIcon} alt="icon.png" /> */}
                  <div className="image">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.73544 10.4035C8.12597 10.013 8.75913 10.013 9.14966 10.4035L12 13.2539L14.8504 10.4035C15.2409 10.013 15.8741 10.013 16.2646 10.4035C16.6551 10.7941 16.6551 11.4272 16.2646 11.8177L12.7071 15.3752C12.3166 15.7657 11.6835 15.7657 11.2929 15.3752L7.73544 11.8177C7.34492 11.4272 7.34492 10.7941 7.73544 10.4035Z"
                        fill="#234D96"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 2.99667C12.5523 2.99667 13 3.44439 13 3.99667V14.6681C13 15.2204 12.5523 15.6681 12 15.6681C11.4477 15.6681 11 15.2204 11 14.6681V3.99667C11 3.44439 11.4477 2.99667 12 2.99667Z"
                        fill="#234D96"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.9967 15.4457C4.54899 15.4457 4.9967 15.8935 4.9967 16.4457C4.9967 17.8582 6.14173 19.0032 7.55419 19.0032H16.4459C17.8583 19.0032 19.0034 17.8582 19.0034 16.4457C19.0034 15.8935 19.4511 15.4457 20.0034 15.4457C20.5557 15.4457 21.0034 15.8935 21.0034 16.4457C21.0034 18.9628 18.9629 21.0032 16.4459 21.0032H7.55419C5.03716 21.0032 2.9967 18.9628 2.9967 16.4457C2.9967 15.8935 3.44442 15.4457 3.9967 15.4457Z"
                        fill="#234D96"
                      />
                    </svg>
                  </div>
                  <div>
                    <p>{item.linkText}</p>
                    <p>{filesize(item.size)}</p>
                  </div>
                </div>
              </a>
            </Grid>
          ))}
        </Grid>
      </>
    );
  };

  const cookieSwitchChangeHandler = event => {
    if (event.target.checked === false) {
      setCookie('VDO_cookieSettings', "{'Google_Analytics_cookieSwitch':false}", 30);
    } else {
      setCookie('VDO_cookieSettings', "{'Google_Analytics_cookieSwitch':true}", 30);
    }
    setCookieContent(event.target.checked);
    window.location.reload();
  };

  const cookieSwitchTemplate = () => {
    if (type === 'public' && pageId === '22') {
      return (
        <>
          <div>
            <h3>{t('cookiePage.optionalCookiesHeading')}</h3>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={10}>
                <p style={{ margin: '0' }}>
                  <strong>{t('cookiePage.googleAnalyticsTitle')}</strong>
                </p>
              </Grid>

              <Grid item xs={2}>
                <IOSSwitch checked={cookieContent} onChange={cookieSwitchChangeHandler} />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={10}>
                <p>{t('cookiePage.googleAnalyticsText')}</p>
              </Grid>

              <Grid item xs={2}></Grid>
            </Grid>
          </div>
        </>
      );
    }
  };

  function setCookie(cname, cvalue, exMins) {
    var d = new Date();
    d.setTime(d.getTime() + exMins * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  const tracking = async item => {
    try {
      const data = {
        uuid: user.uuid,
        nid: parseInt(pageId),
        action: 'click',
        data: item.link
      };
      const response = await axiosInstance.post(`${ENDPOINTS.TRACK_DOWNLOAD_ENDPOINT}`, data);
      return response;
    } catch (error) {
      // console.log(error);
    }
  };

  return (
    <div className="">
      {/* <div className="content-title">
        <h2>{content.title || ''}</h2>
      </div> */}
      <div className="content-block">
        {content.body && <InnerHTML key={Math.random()} html={content.body} />}
        {content.content && <InnerHTML key={Math.random()} html={content.content} />}
        {content.iframe && (
          <iframe
            title="iframe"
            frameborder="0"
            style={{ width: '100%', height: '50vh', marginTop: 20, marginBottom: 20 }}
            src={content?.iframe}
          ></iframe>
        )}
        {content.bodySecondary && <p dangerouslySetInnerHTML={{ __html: content?.bodySecondary }}></p>}

        {content.downloads && content.downloads.length && (
          <Downloads tracking={tracking} downloads={content.downloads} />
        )}

        {cookieSwitchTemplate()}
      </div>

      {rating > -1 && (
        <Grid className="knowledge-base-your-rating">
          <h3>Your rating</h3>
          <UserRating
            nid={nid}
            clearError={clearError}
            rateDetail={rateDetail}
            loading={loading}
            ratingError={ratingError}
            ratingSuccess={ratingSuccess}
            isNews={isNews}
          />
        </Grid>
      )}

      <div
        className="content-block__back-actions"
        style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center' }}
      >
        {/* <Backbtn kb={kb} /> */}
        <div className="btn-container" style={{ viewTransitionName: 'back-prev-btn' }}>
          <Button
            type="button"
            borderOnly
            noArrow
            secondary
            label={t('backPreviousPage')}
            onClick={() => history.go(-1)}
          />
        </div>
      </div>
    </div>
  );
};

export { ContentBlock };
